<div class="fb-component" [formGroup]="form">
  <div class="fb__header">
    <div class="fb__header-left">
      <div class="fb__title">{{ label }}</div>
      @if (populatedFrom) {
        <div class="fb__note">* populated from {{ populatedFrom }}</div>
      }
    </div>
    <button
      type="button"
      class="fb__toggle"
      (click)="toggleExpanded()"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-label]="isExpanded ? 'Collapse section' : 'Expand section'"
    >
      <rx-icon name="icon-expand" class="fb__chevron blue" [ngClass]="{ rotate180: isExpanded }" [size]="12"></rx-icon>
    </button>
  </div>

  @if (isExpanded) {
    <div class="fb__content">
      <div class="fb__rows" [class.readonly]="_disabled || readonly">
        @for (row of values; track $index; let i = $index) {
          @if (!printMode || showEmptyRowsInPrint || isRowMeaningfulForPrint(row)) {
            <div
              class="fb__row-group"
              [class.fb__row-group--empty]="i === 0 && isRowEmpty(row)"
              [class.fb__row-group--no-actions]="printMode || hideActionButtons"
              (click)="onEmptyRowClick(i, $event)"
              (keydown.enter)="onEmptyRowClick(i, $event)"
              (keydown.space)="onEmptyRowClick(i, $event)"
              [attr.tabindex]="i === 0 && isRowEmpty(row) ? 0 : -1"
              [attr.role]="i === 0 && isRowEmpty(row) ? 'button' : null"
              [attr.aria-disabled]="i === 0 && isRowEmpty(row) ? null : true"
            >
              <div class="fb__row fb__row--fields">
                @for (field of row.fields; track $index; let fieldIndex = $index) {
                  @if (field.type !== 'textarea' && !isHiddenField(field.type)) {
                    <div class="fb__field" [ngClass]="'fb__' + (field.type || 'text')">
                      <div class="fb__label">
                        <span class="fb__label-content">
                          <span>{{ field.title }}</span>
                          <fb-scribe-suggestion-indicator
                            [target]="getRowMarkerTarget(row, i)"
                            [fieldKey]="field.type"
                            [variant]="field.type === 'priority' ? 'full' : 'compact'"
                          ></fb-scribe-suggestion-indicator>
                          <fb-amendment-field-indicator [fieldKey]="amendmentSection + ':r' + i + ':' + field.type" />
                        </span>
                      </div>

                      @if (field.type === 'date') {
                        <div class="fb__date-wrap">
                          <input
                            class="fb__input"
                            type="text"
                            [placeholder]="printMode ? '' : 'MM/DD/YYYY'"
                            [matDatepicker]="picker"
                            [formControl]="getControl(i, fieldIndex)"
                            [attr.aria-label]="field.title"
                            (focus)="picker.open()"
                            (dateChange)="onDateChange(i, fieldIndex, $event.value)"
                            (change)="onFieldEdited(i, fieldIndex)"
                          />
                          <button
                            type="button"
                            class="fb-btn fb-btn--icon fb-btn--calendar"
                            [disabled]="_disabled || readonly || lockDateEmployee"
                            aria-label="Open calendar"
                            (click)="picker.open()"
                          >
                            <rx-icon name="icon-calendar2"></rx-icon>
                          </button>
                          <mat-datepicker #picker></mat-datepicker>
                        </div>
                      }
                      @if (field.type === 'employee') {
                        @if (lockDateEmployee || _disabled || readonly) {
                          <div class="fb__input-wrapper">
                            <input
                              class="fb__input"
                              type="text"
                              [value]="getEmployeeLabel(getControl(i, fieldIndex)?.value)"
                              [attr.aria-label]="field.title"
                              disabled
                            />
                          </div>
                        } @else {
                          <ng-select
                            class="fb__select"
                            [formControl]="getControl(i, fieldIndex)"
                            [items]="employees$ | async"
                            bindLabel="text"
                            bindValue="value"
                            [placeholder]="printMode ? '' : 'Select'"
                            [searchable]="true"
                            [searchFn]="customSearchFn"
                            [virtualScroll]="true"
                            [clearable]="true"
                            [minTermLength]="0"
                            dropdownPosition="auto"
                            appendTo="body"
                            (change)="onFieldEdited(i, fieldIndex)"
                          >
                            <ng-template ng-option-tmp let-item="item">{{ item.text }}</ng-template>
                          </ng-select>
                        }
                      }
                      @if (field.type === 'priority') {
                        <ng-select
                          class="fb__select"
                          [formControl]="getControl(i, fieldIndex)"
                          [items]="priorities"
                          bindLabel="text"
                          bindValue="value"
                          [placeholder]="printMode ? '' : 'None'"
                          [searchable]="false"
                          [clearable]="true"
                          dropdownPosition="auto"
                          appendTo="body"
                          (change)="onFieldEdited(i, fieldIndex)"
                        >
                          <ng-template ng-option-tmp let-item="item">{{ item.text }}</ng-template>
                        </ng-select>
                      }
                      @if (isTextFieldType(field.type)) {
                        <div class="fb__input-wrapper">
                          <input
                            class="fb__input"
                            [attr.type]="field.type === 'plan-items-quantity' ? 'number' : 'text'"
                            [formControl]="getControl(i, fieldIndex)"
                            [placeholder]="printMode ? '' : field.placeholder || 'Enter ' + field.title.toLowerCase()"
                            [attr.aria-label]="field.title"
                            (input)="onFieldEdited(i, fieldIndex)"
                          />
                        </div>
                      }
                    </div>
                  }
                }
                @if (!printMode && !hideActionButtons) {
                  <div class="fb__actions fb__actions--inline">
                    <button
                      type="button"
                      class="fb-btn fb-btn--remove"
                      (click)="removeRow(i)"
                      [disabled]="_disabled || readonly"
                      aria-label="Remove row"
                    >
                      <rx-icon name="icon-close"></rx-icon>
                    </button>
                  </div>
                }
              </div>

              <div class="fb__row fb__row--textarea">
                @for (field of row.fields; track $index; let fieldIndex = $index) {
                  @if (field.type === 'textarea' && !isHiddenField(field.type)) {
                    <div class="fb__textarea-field">
                      <div class="fb__textarea-label">
                        <span>Note</span>
                        <fb-scribe-suggestion-indicator
                          [target]="getRowMarkerTarget(row, i)"
                          fieldKey="note"
                          variant="full"
                        ></fb-scribe-suggestion-indicator>
                        <fb-amendment-field-indicator [fieldKey]="amendmentSection + ':r' + i + ':note'" />
                      </div>
                      <textarea
                        appPasteStrip
                        appTextareaAutosize
                        [appTextareaAutosizeUnlimited]="printMode"
                        class="fb__textarea"
                        [class.fb__textarea--print]="printMode"
                        [formControl]="getControl(i, fieldIndex)"
                        [placeholder]="printMode ? '' : field.placeholder"
                        [attr.aria-label]="field.title"
                        (input)="onFieldEdited(i, fieldIndex)"
                      ></textarea>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      @if (!printMode && !hideActionButtons) {
        <div class="fb__add-actions">
          <button type="button" class="fb-btn fb-btn--add" (click)="addRow()" [disabled]="_disabled || readonly">
            <span class="fb-btn__icon">
              <rx-icon name="icon-circle-plus-2" [size]="16"></rx-icon>
            </span>
            <span>Add {{ addButtonText || label }}</span>
          </button>
        </div>
      }
      @if (!printMode || displayAttributes.length > 0) {
        <div class="fb__attributes" [class.readonly]="_disabled || readonly">
          <div class="fb__attributes-table">
            <div class="fb__attributes-header">
              <span>Assigned Attributes</span>
              @if (!printMode && isScribeSuggestionUsed(sectionMarkerTarget, attributesMarkerKey)) {
                <fb-scribe-suggestion-indicator
                  [target]="sectionMarkerTarget"
                  [fieldKey]="attributesMarkerKey"
                  variant="full"
                ></fb-scribe-suggestion-indicator>
              }
              <fb-amendment-field-indicator [fieldKey]="amendmentSection + '_attributes'" />
            </div>
            @for (attr of displayAttributes; track $index) {
              <div class="fb__attributes-row">{{ attr }}</div>
            }
            @if (!printMode && displayAttributes.length === 0) {
              <div class="fb__attributes-empty">No attributes</div>
            }
          </div>
          @if (!printMode && !hideActionButtons) {
            <button
              type="button"
              class="fb-btn fb-btn--add fb-btn--attribute"
              (click)="addAttribute()"
              [disabled]="_disabled || readonly"
            >
              <span class="fb-btn__icon">
                <rx-icon name="icon-circle-plus-2" [size]="16"></rx-icon>
              </span>
              <span>Add {{ getAttributeLabel() }} Attribute</span>
            </button>
          }
        </div>
      }
      @if (showExtraButton && (!printMode || planItemsView.length > 0)) {
        <div class="fb__plan-items" [class.readonly]="_disabled || readonly">
          <div class="fb__plan-items-title">Plan Items</div>
          <div class="fb__plan-items-table">
            <div class="fb__plan-items-header">
              <div class="fb__plan-items-cell">
                <span class="fb__table-header-content">
                  <span>Item Name</span>
                  @if (
                    !printMode && isAnyScribeSuggestionUsed(sectionMarkerTarget, ['planItems', 'planItemsQuantity'])
                  ) {
                    <fb-scribe-suggestion-indicator
                      [target]="sectionMarkerTarget"
                      [fieldKeys]="['planItems', 'planItemsQuantity']"
                      variant="full"
                    ></fb-scribe-suggestion-indicator>
                  }
                  <fb-amendment-field-indicator [fieldKeys]="['plan_items', 'plan_items_quantity']" />
                </span>
              </div>
              <div class="fb__plan-items-cell fb__plan-items-cell--right">Quantity</div>
            </div>
            @for (item of planItemsView; track $index) {
              <div class="fb__plan-items-row">
                <div class="fb__plan-items-cell">{{ item.name }}</div>
                <div class="fb__plan-items-cell fb__plan-items-cell--right">{{ item.quantity }}</div>
              </div>
            }
            @if (!printMode && planItemsView.length === 0) {
              <div class="fb__plan-items-empty">No plan items</div>
            }
          </div>
          @if (!printMode && !hideActionButtons) {
            <button
              type="button"
              class="fb-btn fb-btn--add"
              (click)="addPlanItems()"
              [disabled]="_disabled || readonly"
            >
              <span class="fb-btn__icon">
                <rx-icon name="icon-circle-plus-2" [size]="16"></rx-icon>
              </span>
              <span>{{ extraButtonText }}</span>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
